import { AlertCircle } from "lucide-react";
import { Label } from "../ui/label";

// components/FormField.tsx
interface FormFieldProps {
  label: string | React.ReactNode;
  description?: string | React.ReactNode;
  error?: string;
  children: React.ReactNode;
}

export function FormField({
  label,
  description,
  error,
  children,
}: FormFieldProps) {
  const hasHeader = Boolean(label || description);
  return (
    <div className={hasHeader ? "space-y-2" : ""}>
      {hasHeader && (
        <div className="space-y-1">
          {label ? <Label className="">{label}</Label> : null}
          {typeof description === "string" ? (
            <p className="text-sm text-muted-foreground font-extralight ">
              {description}
            </p>
          ) : (
            description
          )}
        </div>
      )}
      <div>{children}</div>
      {error && (
        <div className="flex justify-between items-center text-xs mt-1.5">
          <p className="text-sm text-destructive flex items-center gap-1.5">
            <AlertCircle className="w-4 h-4" />
            {error}
          </p>
        </div>
      )}
    </div>
  );
}

